import React, { Component, Fragment } from 'react';
import { BreadCrumb, Card, Loading } from '../../components';
import { Translate, LanguageConsumer } from '../../contexts/LanguageContext';
import { ResearchService } from '../../services/ResearchService';
import { DocumentService } from '../../services/DocumentService';



export class Research extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            content: [],
            root: "",
            document: "",
            view: "d-none",
            documentTitle: "",
            key: ""
        }

        this.onTabChange = this.onTabChange.bind(this)
        this.onReadMore = this.onReadMore.bind(this)
    }
    onTabChange(key) {
        this.setState({ loading: true, content: [] }, () => {

            ResearchService.Research(key).then((response) => {

                if (response) {
                    this.setState({ loading: false, content: response })
                } else {
                    this.setState({ loading: false })
                }

            });

        })
    }
    onReadMore(root, document, title) {

        DocumentService.DocumentKey({ 'root': root, 'document':document  }).then(response => {
            if (response && !response.error) {
                this.setState({
                    root: root,
                    document: document,
                    documentTitle: title,
                    key: response.message
                });
            }

        });


    }
    render() {
        let tabContent = this.state.content.map((item, index) => (
            <div key={index} className="col-md-3">
                <div className="card mini-stat bg-light tra-box__shadow-1">
                    <div className="card-body">
                        <div className="mb-4">
                            <div className="float-left mini-stat-img mr-4">
                                <img src="assets/images/icon-pdf.svg" className="verify-icon" alt="Pdf" height="100" />
                            </div>
                            <h6 className="mt-0">{item.title}</h6>
                            <p className="font-300">{item.createDate}</p>
                        </div>
                        <div className="pt-2 float-right">
                            <button className="btn btn-success waves-effect waves-light btn btn-secondary" onClick={(e) => this.onReadMore(item.root, item.documentUrl, item.title)} data-toggle="modal" data-target=".document-view-modal">{Translate("Read More")}</button>
                        </div>
                    </div>
                </div>
            </div>))

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <BreadCrumb Title={Translate('Research')} Name={Translate('Research')} />
                        <Card className="tra-research__page">
                            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-toggle="tab" href="#disclaimer" role="tab">
                                        <span className="d-block d-sm-none"><i className="fas fa-exclamation"></i></span>
                                        <span className="d-none d-sm-block">{Translate('Disclaimer')}</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#research" role="tab" onClick={(e) => this.onTabChange("focus")}>
                                        <span className="d-block d-sm-none"><i className="fas fa-eye"></i></span>
                                        <span className="d-none d-sm-block">{Translate('Focus')}</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#research" role="tab" onClick={(e) => this.onTabChange("weekAhead")}>
                                        <span className="d-block d-sm-none"><i className="fas fa-calendar-week"></i></span>
                                        <span className="d-none d-sm-block">{Translate('Week Ahead')}</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#research" role="tab" onClick={(e) => this.onTabChange("dailyTechnicalView")}>
                                        <span className="d-block d-sm-none"><i className="fas fa-calendar-day"></i></span>
                                        <span className="d-none d-sm-block">{Translate('Daily Technical View')}</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#research" role="tab" onClick={(e) => this.onTabChange("webinar")}>
                                        <span className="d-block d-sm-none"><i className="fas fa-video"></i></span>
                                        <span className="d-none d-sm-block">{Translate('Webinar')}</span>
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content">
                                <div className="tab-pane active p-3" id="disclaimer" role="tabpanel">
                                    <p className="mb-3">{Translate('These technical and research reports are provided for informative purposes only and in no way can they be considered as a recommendation by ARTSMRKTS to you to engage in any trade. Hence, ARTSMRKTS shall not be held responsible for any outcome of trading decisions, in regards with these reports or similar reports. You hereby acknowledge that using the information entailed in these reports is at your sole responsibility and you will have no claims with regards to these reports against ARTSMRKTS. If you do not agree to this, you are strongly advised not to use these reports.')}</p>
                                    <p className="mb-3">{Translate("This research is for our clients and prospective clients only. Other than disclosures relating to ARTSMRKTS, this research is based on current public information that we consider reliable, but we do not represent that it is accurate or complete, and it should not be relied on as such. The information, opinions, estimates and forecasts contained herein are as of the date hereof and are subject to change without prior notification. We seek to update our research as appropriate, but various regulations may prevent us from doing so. Other than certain industry reports published on a periodic basis, the large majority of reports are published at irregular intervals as appropriate in the analyst's judgment.")}</p>
                                    <p className="mb-3">{Translate("By its very nature, any investment in shares, stock options and similar and assimilated products is characterised by a certain degree of uncertainty and that, consequently, any investment of this nature involves risks for which the user is solely responsible and liable. Investments in securities may decline in value, which may result in the loss of your entire investment.")}</p>
                                    <p className="mb-3">{Translate("We do not provide financial advice to individuals nor assist nor advise in any way as to the personal financial situation of any individual. None of the information provided constitutes individualized investment advice or any legal, accounting, tax or other professional advice. We recommend that our website users not make any investment decision of any sort on the basis of the information and related products set out in our website, unless prior consultation is sought with a professional adviser that has full knowledge of their personal financial situation. Trading may not be suitable for all users of this website.")}</p>
                                    <p className="mb-3">{Translate("None of the services or products contained or referred to on this website are available to persons resident in any country, state or territory where distribution of such services or products would be contrary to local law or regulation.")}</p>
                                    <p className="mb-0">{Translate("Risk Warning: Forex, Commodities, Options and CFDs (OTC Trading) are leveraged products that carry a substantial risk of loss up to your invested capital and may not be suitable for everyone. Please ensure that you fully understand the risks involved and do not invest money you cannot afford to lose. Please refer to our full risk disclaimer.")}</p>
                                </div>
                                <div className="tab-pane p-3" id="research" role="tabpanel">
                                    <div className="row">
                                        {tabContent}
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade document-view-modal" tabIndex="-1" role="dialog" aria-labelledby="DocumentViewModal" aria-hidden="true">
                                <div className="modal-dialog modal-xl">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title mt-0" id="DocumentViewModal">{this.state.documentTitle}</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        </div>
                                        <div className="modal-body">
                                            <iframe id="DocumentView" title="Document View" className="view-frame" src={"https://crm.artsmrkts.com/viewresearch.aspx?file=" + this.state.document + "&root=" + this.state.root + "&control=" + this.state.key} type="application/pdf"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}